import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthUser } from '../shared/interface';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    constructor() { }

    TOKEN_KEY = 'teatro-colosseo-backoffice-auth-token';
    USER_KEY = 'teatro-colosseo-backoffice-auth-data';
    FILTERS_KEY = 'teatro-colosseo-filtri-spettacoli';
    FILTERS_BACKOFFICE_KEY = 'teatro-colosseo-backoffice-filtri-spettacoli';

    user!: AuthUser | undefined;
    subjectUser = new BehaviorSubject(this.user);

    public getToken(): string {
        return localStorage.getItem(this.TOKEN_KEY) || '';
    }

    public getUser(): AuthUser | null {
        let user = localStorage.getItem(this.USER_KEY);
        return user ? JSON.parse(user) : null;
    }

    public getFiltriBackoffice(): {pagina: number, spettacolo: string, dal: string, al: string} | null {
        let filtri = sessionStorage.getItem(this.FILTERS_BACKOFFICE_KEY);
        return filtri ? JSON.parse(filtri) : null;
    }

    public getFiltri(): {pagina: number} | null {
        let filtri = sessionStorage.getItem(this.FILTERS_KEY);
        return filtri ? JSON.parse(filtri) : null;
    }

    setToken(token: string): void {
        localStorage.removeItem(this.TOKEN_KEY);
        localStorage.setItem(this.TOKEN_KEY, token);
    }

    setUser(utente: { user?: string, email?: string, tipo?: string, id?: number, tema?: boolean }): void {
        localStorage.removeItem(this.USER_KEY);
        localStorage.setItem(this.USER_KEY, JSON.stringify(utente));

        this.user = this.getUser()!;
        this.subjectUser.next({ ...this.user });
    }

    setFiltri(filtro: { pagina?: number }): void {
        sessionStorage.removeItem(this.FILTERS_KEY);
        sessionStorage.setItem(this.FILTERS_KEY, JSON.stringify(filtro));        
    }

    setFiltriBackoffice(filtro: { pagina?: number, spettacolo: string, dal: string, al: string }): void {
        sessionStorage.removeItem(this.FILTERS_BACKOFFICE_KEY);
        sessionStorage.setItem(this.FILTERS_BACKOFFICE_KEY, JSON.stringify(filtro));        
    }

    deleteToken() {
        localStorage.removeItem(this.TOKEN_KEY);
    }

    deleteUser() {
        localStorage.removeItem(this.USER_KEY);
    }

    deleteFiltri() {
        sessionStorage.removeItem(this.FILTERS_KEY);
    }

    deleteFiltriBackoffice() {
        sessionStorage.removeItem(this.FILTERS_BACKOFFICE_KEY);
    }

    clearStorage(): void {

        localStorage.removeItem(this.TOKEN_KEY);
        localStorage.removeItem(this.USER_KEY);
        sessionStorage.removeItem(this.FILTERS_KEY);
        sessionStorage.removeItem(this.FILTERS_BACKOFFICE_KEY);

        this.user = this.getUser()!;
        this.subjectUser.next(undefined);
    }
}